import { Links } from "../components/Header";

export const listLinks: Array<Links> = [
	{ text: 'news', address: '/' },
	{ text: 'currency', address: '/' },
	{ text: 'commodities', address: '/' },
];
